// React Native is broken but this is a workaround
export const ensuredFocusProps = {
  blurOnSubmit: false, // if this is not false, focus will be lost eventually on submit
  autoCapitalize: "none", // if this is omitted, iOS won't call onSubmitEditing when selected
  selectTextOnFocus: true,
} as const;

export const COUNT_INPUT_WIDTH = 200;
export const FOOTER_BUTTON_WIDTH = 120;
export const FOOTER_BREAKPOINT = 630;
export const RADIO_BUTTON_SIZE = 14;
